module.exports = __webpack_public_path__ + "img/icon-package-info-general-light.58ba708.svg";